<template>
  <div
    class="search-input clearfix"
    :class="{
      active: showHistoryBox && searchTipList.length > 0,
      'is-vocab': isVocabulary,
    }"
  >
    <div class="input-container clearfix">
      <i data-io-click="tracker"  @click="handleSubmit" class="iconfont icon-sousuon"></i>
      <input
        @focus="handleFocus"
        @blur="handleBlur"
        @input="handleInput"
        v-model="keyword"
        @keyup.enter="handleSubmit"
        type="text"
        ref="searchInput"
        :placeholder="isVocabulary ? '请输入英语词汇' : '输入搜索关键词'"
      />
      <!-- <div data-io-click="tracker"  @click="handleSubmit">搜索</div> -->
    </div>
    <!-- v-if="showHistoryBox && searchTipList.length > 0" -->
    <ul
      ref="historyBox"
      v-if="showHistoryBox && searchTipList.length > 0"
      class="history-box"
    >
      <!-- <div class="line"></div>
      <li
        v-for="(item, index) in searchTipList"
        :key="index"
        :class="{ active: selectIndex == index }"
        data-io-click="tracker"  @click="jumpSearchResultList(item)"
      >
        <i class="iconfont icon-search"></i><span v-html="item.showText"></span>
      </li>
      <li class="clear-li" v-if="!keyword.length" data-io-click="tracker"  @click="clearHistoryList">
        清除历史记录
      </li> -->
      <div
        v-for="(item, index) in searchTipList"
        :key="index"
        v-if="item.showText"
      >
        <p
          class="history-tip"
          v-if="
            !keyword.length && !item.isHot && item.index == 1 && !isVocabulary
          "
        >
          <span> 历史记录</span>
          <span data-io-click="tracker"  @click="handleClearHistory" class="clear-icon">清除历史</span>
        </p>
        <p
          class="hot-tip"
          v-if="item.isHot && item.index == 1 && !isVocabulary"
        >
          <span>热词搜索</span>
        </p>
        <li
          data-io-click="tracker"  @click.stop="jumpSearchResultList(item)"
          :class="{ active: selectIndex == index }"
          :name="
            item.isHot
              ? 'inner_search_hot_' + item.index
              : 'inner_search_history_' + item.index
          "
        >
          <i
            v-if="!isVocabulary"
            class="iconfont"
            :class="[
              item.isHot ? 'icon-hot1' : 'icon-search',
              item.index <= 3 ? 'active' : '',
            ]"
          ></i>
          <span v-html="item.showText"></span>
          <span class="enword-meanings" v-if="isVocabulary">
            {{ item.enWordMeanings.join(";") }}
          </span>
        </li>
      </div>
    </ul>
    <!-- {{ showHistoryBox }} ---- {{ searchTipList }} -->
  </div>
</template>
<script>
const SEARCHHISTORY = "SEARCHHISTORY";
import Cookie from "js-cookie";
import request from "@/utils/request";
import api from "@/assets/js/service/api";
import { mapState } from "vuex";
let stop = null;
export default {
  props: {
    // 来源 1表示搜索主页 2表示搜索结果页面搜索框
    source: {
      type: Number,
      default: 1,
    },
    // 是否是英语词汇
    isVocabulary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showHistoryBox: false,
      keyword: "",
      //搜索提示列表
      searchTipList: [],
      // 选中的索引
      selectIndex: -1,
    };
  },
  computed: {
    ...mapState(["currentCourse"]),
  },
  watch: {
    $route: {
      handler(to, from) {
        this.keyword = this.$route.query.title || this.$route.query.word || "";
      },
      deep: true,
      immediate: true,
    },
    showHistoryBox(newVal) {},
    keyword(val) {
      if (!val) {
        //   // 解决当清空的时候上一次的结果还没出来就清空了所以清空的时候先终止上一次的
        if (stop) {
          stop();
        }
      }
      this.selectIndex == -1 && this.getSearchList();
    },
  },
  mounted() {
    this.showHistoryBox = false;
    this.searchTipList.length = 0;
    document.addEventListener("mouseup", this.mouseUp);
    // document.addEventListener("mouseleave", this.mouseLeave);
    // 监听上下键
    this.$nextTick(() => {
      document.addEventListener("keyup", this.keyUp); //创建监听键盘事件
      this.$refs.searchInput.blur();
    });
  },
  destroyed() {
    document.removeEventListener("mouseup", this.mouseUp);
    // document.removeEventListener("mouseleave", this.mouseLeave);
    document.removeEventListener("keyup", this.keyUp);
    this.showHistoryBox = false;
    this.searchTipList.length = 0;
  },
  methods: {
    mouseLeave(e) {
      this.showHistoryBox = false;
    },
    mouseUp(e) {
      e = e || window.event;
      let target = e.target;
      let historyBox = this.$refs.historyBox;
      let searchInput = this.$refs.searchInput;
      if (
        (historyBox && historyBox.contains(target)) ||
        target == historyBox ||
        target == searchInput
      ) {
        this.showHistoryBox = true;
      } else {
        this.showHistoryBox = false;
        this.searchTipList = [];
      }
    },
    keyUp(e) {
      // 如果搜索列表为孔，不执行下方逻辑
      if (this.searchTipList.length === 0) {
        return;
      }
      if (e.keyCode == 40) {
        // 下键盘
        if (this.selectIndex >= this.searchTipList.length - 1) {
          this.selectIndex = 0;
        } else {
          this.selectIndex = this.selectIndex + 1;
        }
      } else if (e.keyCode == 38) {
        // 上键盘
        if (this.selectIndex == 0) {
          this.selectIndex = this.searchTipList.length - 1;
        } else {
          this.selectIndex = this.selectIndex - 1;
        }
      }
      this.selectIndex >= 0
        ? (this.keyword = this.isVocabulary
            ? this.searchTipList[this.selectIndex].text.word
            : this.searchTipList[this.selectIndex].text)
        : null;
    },
    // 清楚历史记录
    handleClearHistory() {
      // 清楚缓存
      Cookie.remove(SEARCHHISTORY);
      this.getSearchList();
    },
    clearHistoryList() {
      Cookie.remove(SEARCHHISTORY);
      if (!this.keyword) {
        this.searchTipList = [];
        this.showHistoryBox = false;
      } else {
        this.showHistoryBox = true;
      }
    },
    jumpSearchResultList(item) {
      this.showHistoryBox = false;
      this.addSearchHistory(item.text);
      this.$emit("submit", {
        keyword: this.isVocabulary ? item.text.word : item.text,
      });
    },
    async getSearchList() {
      if (stop) {
        stop();
      }
      const status = {
        clear: false,
      };
      stop = () => {
        status.clear = true;
      };
      let searchHistory = Cookie.get(SEARCHHISTORY) || [];
      let apiStr = this.isVocabulary
        ? api.endict.wordSearch
        : api.search.searchRecommends;
      let params = this.isVocabulary
        ? {
            word: this.keyword,
          }
        : {
            content: encodeURIComponent(this.keyword),
          };
      if (!searchHistory.length) {
        Cookie.set(SEARCHHISTORY, JSON.stringify([]));
      } else {
        searchHistory = JSON.parse(decodeURIComponent(searchHistory));
      }

      if (!this.keyword.length) {
        // 查询搜索热词
        // console.log("currentCourse", this.currentCourse);
        let { stageId, subjectId } = this.currentCourse;
        let data = await request.postJson(api.search.hotSearchSite, {
          size: 5,
          stageId,
          subjectId,
        });
        this.hotSearchWords = data.result.slice(0, 5) || [];
        this.hotSearchWords = this.hotSearchWords.map((item, index) => {
          return {
            showText: item,
            text: item,
            isHot: true,
            index: index + 1,
          };
        });
        let isSearchResultPage =
          this.$route.path.indexOf("/search/result") > -1;
        if (isSearchResultPage) {
          let currentSearchWord =
            this.$route.query && this.$route.query.title
              ? this.$route.query.title
              : "";
          searchHistory = searchHistory.filter(
            (item) => item != currentSearchWord
          );
        }
        // 显示对应的历史记录
        searchHistory = searchHistory.map((item) => {
          const reg = new RegExp(this.keyword, "g");
          return {
            showText: item.replace(reg, `<i class='key'>${this.keyword}</i>`),
            text: item,
            // 是否是热词
            isHot: false,
          };
        });
        this.searchTipList = searchHistory
          .reverse()
          .slice(0, 5)
          .map((item, index) => {
            item.index = index + 1;
            return item;
          })
          .concat(this.hotSearchWords);
      } else {
        // 显示联想词
        let searchTipList = await request.get(apiStr, params);
        searchTipList =
          searchTipList.result.slice(0, 10).map((item) => {
            const reg = new RegExp(this.keyword, "g");
            let text = this.isVocabulary ? item.word : item;
            let enWordMeanings = this.isVocabulary
              ? item.wordMeanRespDTOList.map((item) => {
                  return item.wordClass + item.means.join(";");
                })
              : [];
            return {
              showText: text.replace(reg, `<i class='key'>${this.keyword}</i>`),
              text: item,
              enWordMeanings,
            };
          }) || [];
        if (!status.clear) {
          this.searchTipList = searchTipList;
        }
      }
    },
    handleFocus() {
      // this.showHistoryBox = true;
      this.getSearchList();
    },
    handleBlur(e) {
      // this.showHistoryBox = false;
    },
    handleInput(e) {
      // 获取输入词相关的关键词
      this.selectIndex = -1;
      // this.getSearchList();
    },
    addSearchHistory(keyword) {
      let searchHistory = Cookie.get(SEARCHHISTORY) || [];
      if (searchHistory.length > 0) {
        searchHistory = JSON.parse(decodeURIComponent(searchHistory));
      }
      let findIndex = searchHistory.findIndex((item) => {
        return keyword == item;
      });

      if (findIndex == -1) {
        searchHistory.push(keyword);
        Cookie.set(SEARCHHISTORY, JSON.stringify(searchHistory));
      }
    },
    // 提交跳转
    handleSubmit() {
      // console.log("回车");
      this.showHistoryBox = false;
      if (this.keyword.length > 0) {
        this.addSearchHistory(this.keyword);
        this.$refs.searchInput.blur();
        this.$emit("submit", { keyword: this.keyword });
      } else {
        // if (this.source == 1) {
        this.$message(
          this.isVocabulary ? "请输入英语词汇" : "请输入搜索关键字"
        );
        // } else {
        //   // this.$router.push("/search");
        // }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.search-input {
  //   margin: 0 auto;
  width: 572px;
  height: 50px;
  border-radius: 12px;
  background: #eff1f4;
  // box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.06);
  // overflow: hidden;
  position: relative;

  &.active {
    border-radius: 12px 12px 0 0;
    box-shadow: none;

    .input-container {
      input {
        font-size: 16px;
        box-sizing: border-box;
        float: left;
        // width: 564px;
        // padding-left: 48px;
        height: 50px;
        overflow: hidden;
        border-radius: 12px 12px 0 0;
        border: 2px solid #0057ff;
        // border-radius: 12px 0px 0px 0px;
        border-bottom: none;
        // background: #fff;
        text-shadow: none;
        -webkit-appearance: none;
        -webkit-user-select: text;
        outline-color: transparent;
        box-shadow: none;
      }

      div {
        background: #0057ff;
        line-height: 50px;
        border-radius: 0 50px 50px 0;
        text-align: center;
        font-size: 17px;
        color: #fff;
        width: 92px;
        float: left;
      }
    }
  }

  .input-container {
    position: relative;

    i {
      position: absolute;
      font-size: 18px;
      color: #cccccc;
      margin-top: 16px;
      border-radius: 50px;
      right: 20px;
      cursor: pointer;
    }

    input {
      font-size: 16px;
      box-sizing: border-box;
      border: 2px solid transparent;
      float: left;
      width: 100%;
      background: transparent;
      // width: 564px;
      padding-left: 24px;
      height: 50px;
      overflow: hidden;
      // border-radius: 50px 0 0 50px;

      &:focus {
        // border: 2px solid #0057ff;
        // border-radius: 12px 0px 0px 0px;
        // border-bottom: none;
        // background: #fff;
        // text-shadow: none;
        // -webkit-appearance: none;
        // -webkit-user-select: text;
        // outline-color: transparent;
        // box-shadow: none;
      }

      &:-webkit-autofill,
      select:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px white inset !important;
      }
    }

    div {
      background: #0057ff;
      line-height: 50px;
      border-radius: 0 50px 50px 0;
      text-align: center;
      font-size: 17px;
      color: #fff;
      width: 92px;
      float: left;
      cursor: pointer;
    }
  }

  .history-box {
    background: #fff;
    // display: block;
    //   margin: 0 auto;
    max-height: 575px;
    overflow: hidden;
    overflow-y: auto;
    width: 572px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
    border-radius: 0 0px 12px 12px;
    border: 2px solid #0057ff;
    border-top: none;
    position: absolute;
    top: 50px;
    z-index: 100;

    li {
      margin-bottom: 6px;
      cursor: pointer;
      height: 42px;
      line-height: 42px;
      padding: 0 17px;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      i {
        font-size: 18px;
        color: #80848b;
        margin-right: 10px;
        vertical-align: middle;

        &.icon-hot1 {
          &.active {
            color: #fe4509;
          }
        }
      }

      span {
        ::v-deep .key {
          font-style: normal;
          color: #fe4509;
        }
      }

      &.active {
        // color: #0057ff;
        background: #f6f7f9;

        span {
          ::v-deep .key {
            color: #fe4509;
            font-style: normal;
          }
        }
      }

      &:hover {
        background: #f6f7f9;
      }
    }

    p {
      line-height: 1;
      color: #80848b;
      font-size: 14px;
      display: flex;
      // padding: 0 17px;
      margin: 0 17px;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 13px;

      .clear-icon {
        cursor: pointer;
      }

      &.hot-tip {
        padding-top: 20px;
        border-top: 1px solid #e6e7e9;
      }

      &.history-tip {
        padding-top: 16px;
        // border-top: 2px solid #e6e7e9;
      }
    }
  }
  &.is-vocab {
    width: 420px;
    height: 36px;
    border-radius: 8px;
    .input-container {
      input {
        height: 36px;
        border: 1px solid transparent;
        padding-left: 12px;
        &::-webkit-input-placeholder {
          color: #bababa;
          font-size: 12px;
        }
      }
      i {
        margin-top: 9px;
        right: 12px;
        font-size: 16px;
      }
    }
    &.active {
      .input-container {
        input {
          border: 1px solid #0057ff;
          border-radius: 8px;
        }
      }
    }
    .history-box {
      width: 420px;
      padding: 12px 16px;
      box-shadow: 0px 4px 6px -2px rgba(0, 0, 0, 0.08),
        0px 2px 10px 0px rgba(0, 0, 0, 0.06),
        0px 2px 8px 0px rgba(0, 0, 0, 0.08);
      border: none;
      top: 36px;
      li {
        height: 20px;
        line-height: 20px;
        padding: 0;
        margin-bottom: 9px;
        color: #7e7e7e;
        span {
          color: #000;
          ::v-deep .key {
            color: #0057ff;
            // color: #333;
          }
          &.enword-meanings {
            margin-left: 12px;
            font-size: 12px;
            color: #7e7e7e;
          }
        }
      }
    }
  }
}
</style>
